import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import it from './locales/it.json'
import es from './locales/es.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import pt from './locales/pt.json'
import zh from './locales/zh.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'
import ru from './locales/ru.json'
import hi from './locales/hi.json'
import ar from './locales/ar.json'
import id from './locales/id.json'
import ms from './locales/ms.json'
import bn from './locales/bn.json'
import ur from './locales/ur.json'
import tr from './locales/tr.json'
import pl from './locales/pl.json'
import nl from './locales/nl.json'
import sv from './locales/sv.json'
import uk from './locales/uk.json'
import vi from './locales/vi.json'
import th from './locales/th.json'
import fa from './locales/fa.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      it: { translation: it },
      es: { translation: es },
      fr: { translation: fr },
      de: { translation: de },
      pt: { translation: pt },
      zh: { translation: zh },
      ja: { translation: ja },
      ko: { translation: ko },
      ru: { translation: ru },
      hi: { translation: hi },
      ar: { translation: ar },
      id: { translation: id },
      ms: { translation: ms },
      bn: { translation: bn },
      ur: { translation: ur },
      tr: { translation: tr },
      pl: { translation: pl },
      nl: { translation: nl },
      sv: { translation: sv },
      uk: { translation: uk },
      vi: { translation: vi },
      th: { translation: th },
      fa: { translation: fa },
    },
    fallbackLng: 'en',
    detection: { order: ['navigator', 'htmlTag'] },
    interpolation: { escapeValue: false },
  })

export default i18n
